// extracted by mini-css-extract-plugin
module.exports = {"wrap":"IndustryCode-hashed__wrap__sPlym","textStyle":"IndustryCode-hashed__textStyle__3Fx0h"};